import React, { FC } from 'react';
import { Waypoint } from 'react-waypoint';

import LoaderContent from 'components/UI/LoaderContent';
import FirstUp from 'components/Card/FirstUp/FirstUp';

import { CardSchema } from 'constants/graphqlTypes';
import { IUseCardsBaseSelection } from 'pages/OnboardingV2/ContentTutorial/ListFill/models';
import { CardSchemaWithIsViewed } from 'graphQL/savedPicks/models';
import {
  StyledSavedPicksWrap,
  StyledCardWrap,
  StyledCardContent,
  StyledSelectionOverlay,
  StyledCheckbox,
} from './styled';

import EmptyPageContent from '../EmptyPageContent';

interface ISavedPicksContentProps {
  isDark: boolean;
  cards?: CardSchema[];
  loading: boolean;
  loadMore: () => void;
  isSelectable: boolean;
  cardsSelection?: IUseCardsBaseSelection;
}

const CheckIcon: FC = () => (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_8_2)">
      <path
        d="M1 5.5L4.28694 8.62259C4.50022 8.82521 4.84147 8.80081 5.02375 8.56991L11 1"
        stroke="#181800"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_2">
        <rect width="12" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SavedPicksContent: FC<ISavedPicksContentProps> = ({
  isDark,
  cards,
  loading,
  loadMore,
  isSelectable,
  cardsSelection,
}) => {
  const { selectedCards, handleCardClick } = cardsSelection ?? {};

  const handleOverlayClick = (e: React.MouseEvent, cardId: string) => {
    e.stopPropagation();
    if (handleCardClick) {
      handleCardClick(cardId);
    }
  };

  return cards?.length ? (
    <StyledSavedPicksWrap>
      {/* One-up list using the common Card component */}
      {cards.map((card) => {
        const isSelected = selectedCards?.includes(card.cardId) ?? false;

        return (
          <StyledCardWrap key={card.id}>
            {isSelectable && (
              <StyledSelectionOverlay
                isSelected={isSelected}
                onClick={(e) => handleOverlayClick(e, card.cardId)}
                role="button"
                aria-label={isSelected ? 'Deselect saved pick' : 'Select saved pick'}
                aria-pressed={isSelected}
              >
                <StyledCheckbox isSelected={isSelected}>{isSelected && <CheckIcon />}</StyledCheckbox>
              </StyledSelectionOverlay>
            )}
            <StyledCardContent isSelectable={isSelectable}>
              <FirstUp
                card={card}
                isDark={isDark}
                referrerUserId={(card as CardSchemaWithIsViewed).referrerUserId}
                sourcePickId={(card as CardSchemaWithIsViewed).sourcePickId}
                isSavedPicksView
                showReactionButton={false}
                disableAnimation
                hideFooterMenu={isSelectable}
              />
            </StyledCardContent>
          </StyledCardWrap>
        );
      })}
      {!loading && <Waypoint onEnter={loadMore} />}
    </StyledSavedPicksWrap>
  ) : (
    <>{loading ? <LoaderContent isFullScreen isDark={isDark} /> : <EmptyPageContent isDark={isDark} />}</>
  );
};

export default SavedPicksContent;
